<template>
  <div
    class="dvs-dropdown-field"
    :class="{ 'is-open': isOpen }"
    ref="dropdownRef"
  >
    <label v-if="label" class="dvs-form-label">
      {{ label }}
    </label>

    <div class="dvs-dropdown">
      <button
        type="button"
        class="dvs-dropdown-trigger"
        :class="{
          'has-value': selectedOption,
          'is-error': error
        }"
        role="combobox"
        :aria-expanded="isOpen"
        @click="toggle"
        @keydown.escape.prevent="close"
      >
        <template v-if="selectedOption">
          <span
            v-if="selectedOption.hex"
            class="dvs-color-swatch"
            :style="{ background: selectedOption.hex }"
          ></span>

          <span
            v-if="selectedOption.code"
            class="dvs-product-code"
          >
            {{ selectedOption.code }}
          </span>

          <span class="dvs-dropdown-name">
            {{ selectedOption.label }}
          </span>
        </template>

        <span v-else class="dvs-dropdown-placeholder">
          {{ placeholder }}
        </span>

        <span class="dvs-chevron" aria-hidden="true">
          <i class="bi bi-chevron-down"></i>
        </span>
      </button>

      <div class="dvs-dropdown-menu" :class="{ open: isOpen }">
        <button
          v-for="option in options"
          :key="option.value"
          type="button"
          class="dvs-dropdown-option"
          :class="{ selected: option.value === modelValue }"
          @click="selectOption(option)"
        >
          <span
            v-if="option.hex"
            class="dvs-color-swatch"
            :style="{ background: option.hex }"
          ></span>

          <span
            v-if="option.code"
            class="dvs-product-code"
          >
            {{ option.code }}
          </span>

          <span class="dvs-dropdown-option-label">
            {{ option.label }}
          </span>

          <i
            v-if="option.value === modelValue"
            class="bi bi-check2 dvs-check"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    </div>

    <p v-if="error && errorMessage" class="dvs-error-message">
      {{ errorMessage }}
    </p>

    <p v-else-if="helper" class="dvs-helper-text">
      {{ helper }}
    </p>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean],
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: 'Seleccionar'
  },
  options: {
    type: Array,
    default: () => []
  },
  error: {
    type: Boolean,
    default: false
  },
  errorMessage: {
    type: String,
    default: ''
  },
  helper: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue', 'select', 'blur'])

const isOpen = ref(false)
const dropdownRef = ref(null)

const selectedOption = computed(() => {
  return props.options.find((option) => option.value === props.modelValue)
})

function toggle() {
  isOpen.value = !isOpen.value
}

function close() {
  if (!isOpen.value) return

  isOpen.value = false
  emit('blur')
}

function selectOption(option) {
  emit('update:modelValue', option.value)
  emit('select', option)
  close()
}

function handleClickOutside(event) {
  if (!dropdownRef.value) return

  if (!dropdownRef.value.contains(event.target)) {
    close()
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>
